import Swiper, { Autoplay, Keyboard, EffectFade } from 'swiper';

Swiper.use([Autoplay, Keyboard, EffectFade]);

const changeActiveEl = (el, index) => {
  const prevActive = el.querySelector('.case.active');

  if(prevActive ){ 
    prevActive.classList.remove('active');
  }
  const activeCase = el.querySelector(`[data-slide="${index}"]`);
  if(activeCase ){ 

    activeCase.classList.add('active');
  }
};


const sliderLinkedBg = () => {

  const sliders = document.querySelectorAll('.bg-userCases');
  sliders.forEach(slider => {
    // add data-linked attribute on the slider
    const selectorLinked = slider.getAttribute('data-linked');
    const elLinked = document.querySelector(selectorLinked);


    new Swiper(slider, {
      loop: true,
      grabCursor: false,
      slidesPerView: 1,
      initialSlide: 0,
      effect: 'fade',
      speed: 500,
      fadeEffect: {
        crossFade: true,
      },
      autoplay :{
        disableOnInteraction : false,
        pauseOnMouseEnter: true
      },

      on: {

        init: function (swiper) {
          for (const child of elLinked.children) {
            child.addEventListener('mouseover', (event) => {

              let sliderIndex = event.target.getAttribute('data-slide');  // get slide number and slide to it        
             
              if (sliderIndex) {
                swiper.slideTo(sliderIndex);
                changeActiveEl(elLinked, sliderIndex);
                swiper.autoplay.stop()
              }
            });

            child.addEventListener('mouseleave', () => {
              swiper.autoplay.start()
            });
          };
        },

        slideChange : function ( swiper){
          changeActiveEl(elLinked, (swiper.realIndex + 1));
        }
      },

    })
  });

}

export default sliderLinkedBg;

